import { getReporteImagenShareAllCount } from "../services/binnacleService";
import { getMetricaEgresosMensual, getMetricaEntradas, getMetricaEntrasMensual, getMetricaEntrasMetodoPago, getMetricaSalidas, getReporteEgresosDolares, getReporteEgresosPesos, getReporteIngresos } from "../services/metricService";
import { getGrupoViajeUtilidadFecha } from "../services/serviceViaje"
const dataInicial = {
  utilidadLiquidaciones: {},
  metricaIngresos: {},
  metricaIngresosMesnsuales: [],
  metricaIngresosMetodoPago: {},
  metricaEgresos: {},
  metricaEgresosMensuales: [],
  ingresoFechaIncio: new Date(),
  ingresoFechaFin: new Date(),
  egresosFechaInicio: new Date(),
  egresosFechaFin: new Date(),
  exito: 0,
  //* Reporte de imagenes
  reporteImagenes: {}
}
const ADD_REPORTES_FECHAS_FINAL_INGRESO_ACTION = "ADD_REPORTES_FECHAS_FINAL_INGRESO_ACTION"
const ADD_REPORTES_FECHAS_INICIO_INGRESO_ACTION = "ADD_REPORTES_FECHAS_INICIO_INGRESO_ACTION"
const ADD_RESPOTES_FECHAS_INICIO_EGRESO_ACTION = "ADD_RESPOTES_FECHAS_INICIO_EGRESO_ACTION"
const ADD_RESPOTES_FECHAS_FINAL_EGRESO_ACTION = "ADD_RESPOTES_FECHAS_FINAL_EGRESO_ACTION"
const GET_REPORTES_INGRESOS_MENSUALES_ACTION = "GET_REPORTES_INGRESOS_MENSUALES_ACTION"
const GET_REPORTES_EGRESOS_MENSUALES_ACTION = "GET_REPORTES_EGRESOS_MENSUALES_ACTION"
const GET_REPORTES_EGRESOS_PAGOS = "GET_REPORTES_EGRESOS_PAGOS"
const GET_REPORTES_INGRESOS_PAGOS = "GET_REPORTES_INGRESOS_PAGOS"
const GET_REPORTES_INGRESOS_PAGOS_METODO = "GET_REPORTES_INGRESOS_PAGOS_METODO"
const GET_REPORTES_UTILIDAD_LIQUIDACIONES = "GET_REPORTES_UTILIDAD_LIQUIDACIONES"
const GET_REPOSTES_INGRESOS_REPORTE = "GET_REPOSTES_INGRESOS_REPORTE"
const GET_REPORTES_EGRESOS_REPORTE = "GET_REPORTES_EGRESOS_REPORTE"
const CLEAR_STATE = "CLEAR_STATE"
//* Reporte de imagenes
const GET_REPORTES_IMAGENES_SHARE_ACTION = "GET_REPORTES_IMAGENES_SHARE_ACTION"


export default function reportesReducer(state = dataInicial, action) {
  switch (action.type) {
    case GET_REPORTES_EGRESOS_MENSUALES_ACTION:
      return { ...state, metricaEgresosMensuales: action.payload.metricaEgresosMensuales }
    case GET_REPORTES_INGRESOS_MENSUALES_ACTION:
      return { ...state, metricaIngresosMesnsuales: action.payload.metricaIngresosMesnsuales }
    case GET_REPORTES_EGRESOS_REPORTE:
      return { ...state, exito: action.payload.exito }
    case ADD_RESPOTES_FECHAS_FINAL_EGRESO_ACTION:
      return { ...state, egresosFechaFin: action.payload.egresosFechaFin }
    case ADD_RESPOTES_FECHAS_INICIO_EGRESO_ACTION:
      return { ...state, egresosFechaInicio: action.payload.egresosFechaInicio }
    case ADD_REPORTES_FECHAS_FINAL_INGRESO_ACTION:
      return { ...state, ingresoFechaFin: action.payload.ingresoFechaFin }
    case ADD_REPORTES_FECHAS_INICIO_INGRESO_ACTION:
      return { ...state, ingresoFechaIncio: action.payload.ingresoFechaIncio }
    case GET_REPOSTES_INGRESOS_REPORTE:
      return { ...state, exito: action.payload.exito }
    case GET_REPORTES_EGRESOS_PAGOS:
      return { ...state, metricaEgresos: action.payload.metricaEgresos }
    case GET_REPORTES_INGRESOS_PAGOS_METODO:
      return { ...state, metricaIngresosMetodoPago: action.payload.metricaIngresosMetodoPago }
    case GET_REPORTES_INGRESOS_PAGOS:
      return { ...state, metricaIngresos: action.payload.metricaIngresos }
    case GET_REPORTES_UTILIDAD_LIQUIDACIONES:
      return { ...state, utilidadLiquidaciones: action.payload.utilidadLiquidaciones }
    case CLEAR_STATE:
      return {
        ...state,
        ItemsIndiviudal: action.payload.ItemsIndiviudal,
      };
    //* Reporte de imagenes
    case GET_REPORTES_IMAGENES_SHARE_ACTION:
      return { ...state, reporteImagenes: action.payload.reporteImagenes }
    default:
      return state;
  }
}
//* metodos de egresos
export const obtenerEgresosMensualesAction = ({ FechaIni, FechaFin }) => async (dispatch) => {
  return await getMetricaEgresosMensual({ FecFin: FechaFin, FecIni: FechaIni }).then(Response => {
    dispatch({
      type: GET_REPORTES_EGRESOS_MENSUALES_ACTION,
      payload: {
        metricaEgresosMensuales: Response
      }
    })
    return Response
  }).catch(Error => {
    return Error
  })
}
export const addFechasEgresosFinalAction = ({ FechaFin }) => (dispatch) => {
  dispatch({
    type: ADD_RESPOTES_FECHAS_FINAL_EGRESO_ACTION,
    payload: {
      egresosFechaFin: FechaFin,
    }
  })
}
export const addFechasEgresosIncioAction = ({ FechaIni }) => (dispatch) => {
  dispatch({
    type: ADD_RESPOTES_FECHAS_INICIO_EGRESO_ACTION,
    payload: {
      egresosFechaInicio: FechaIni,
    }
  })
}
export const obtenerEgresosReporteAction = ({ FechaIni, FechaFin }) => async (dispatch) => {
  return await getMetricaSalidas({ FecFin: FechaFin, FecIni: FechaIni }).then(Response => {
    dispatch({
      type: GET_REPORTES_EGRESOS_PAGOS,
      payload: {
        metricaEgresos: Response
      }
    })
  }).catch(Error => {
    return Error
  })
}
export const otenerReporteEgresosUsdAction = ({ FechaIni, FechaFin }) => async (dispatch) => {
  return await getReporteEgresosDolares({ FecFin: FechaFin, FecIni: FechaIni }).then(Response => {
    dispatch({
      type: GET_REPORTES_EGRESOS_REPORTE,
      payload: {
        exito: 1
      }
    })
    return Response
  }).catch(Error => {
    return Error
  })
}
export const otenerReporteEgresosMxnAction = ({ FechaIni, FechaFin }) => async (dispatch) => {
  return await getReporteEgresosPesos({ FecFin: FechaFin, FecIni: FechaIni }).then(Response => {
    dispatch({
      type: GET_REPORTES_EGRESOS_REPORTE,
      payload: {
        exito: 1
      }
    })
    return Response
  }).catch(Error => {
    return Error
  })
}
//* metodos de ingresos
export const obtenerIngresosMensualesACtion = ({ FechaIni, FechaFin }) => async (dispatch) => {
  return await getMetricaEntrasMensual({ FecFin: FechaFin, FecIni: FechaIni }).then(Response => {
    dispatch({
      type: GET_REPORTES_INGRESOS_MENSUALES_ACTION,
      payload: {
        metricaIngresosMesnsuales: Response
      }
    })
    return Response
  }).catch(Error => {
    return Error
  })
}
export const addFechasIngresosFinalAction = ({ FechaFin }) => (dispatch) => {
  dispatch({
    type: ADD_REPORTES_FECHAS_FINAL_INGRESO_ACTION,
    payload: {
      ingresoFechaFin: FechaFin,
    }
  })
}
export const addFechasIngresosIncioAction = ({ FechaIni }) => (dispatch) => {
  dispatch({
    type: ADD_REPORTES_FECHAS_INICIO_INGRESO_ACTION,
    payload: {
      ingresoFechaIncio: FechaIni,
    }
  })
}
export const otenerReporteIngresosAction = ({ FechaIni, FechaFin }) => async (dispatch) => {
  return await getReporteIngresos({ FecFin: FechaFin, FecIni: FechaIni }).then(Response => {
    dispatch({
      type: GET_REPOSTES_INGRESOS_REPORTE,
      payload: {
        exito: 1
      }
    })
    return Response
  }).catch(Error => {
    return Error
  })
}
export const obtenerIngresosReporteMetodoPagoAction = ({ FechaIni, FechaFin }) => async (dispatch) => {
  return await getMetricaEntrasMetodoPago({ FecFin: FechaFin, FecIni: FechaIni }).then(Response => {
    dispatch({
      type: GET_REPORTES_INGRESOS_PAGOS_METODO,
      payload: {
        metricaIngresosMetodoPago: Response
      }
    })
  }).catch(Error => {
    return Error
  })
}
export const obtenerIngresosReporteAction = ({ FechaIni, FechaFin }) => async (dispatch) => {
  return await getMetricaEntradas({ FecFin: FechaFin, FecIni: FechaIni }).then(Response => {
    dispatch({
      type: GET_REPORTES_INGRESOS_PAGOS,
      payload: {
        metricaIngresos: Response
      }
    })
  }).catch(Error => {
    return Error
  })
}
export const obtenerUtilidadLiquidacionesAction = ({ FechaIni, FechaFin }) => async (dispatch) => {
  return await getGrupoViajeUtilidadFecha({ FechaFin, FechaIni }).then(Resposne => {
    dispatch({
      type: GET_REPORTES_UTILIDAD_LIQUIDACIONES,
      payload: {
        utilidadLiquidaciones: Resposne
      }
    })
  })
}
export const clearState = () => async (dispatch) => {
  dispatch({
    type: CLEAR_STATE,
    payload: dataInicial
  })
}
//* Reporte de imagenes
export const obtenerReporteImagenesShareAction = () => async (dispatch) => {
  return await getReporteImagenShareAllCount().then(Response => {
    dispatch({
      type: GET_REPORTES_IMAGENES_SHARE_ACTION,
      payload: {
        reporteImagenes: Response
      }
    })
    return Response
  }).catch(Error => {
    return {}
  })
}